import NotFound from "../components/NotFound/NotFound"

const NotFoundPage = () => (
  <NotFound />
)

export default NotFoundPage